import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-seat-dev.tsx
/**
* icon.16.seat-dev
*
* Keywords: asterisk, star, radial, center, expand, focal, lines, burst
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC41IDIuNWEuNS41IDAgMCAwLTEgMHY0LjI5M0w0LjQ2NCAzLjc1N2EuNS41IDAgMCAwLS43MDcuNzA3TDYuNzkzIDcuNUgyLjVhLjUuNSAwIDAgMCAwIDFoNC4yOTNsLTMuMDM2IDMuMDM2YS41LjUgMCAxIDAgLjcwNy43MDdMNy41IDkuMjA3VjEzLjVhLjUuNSAwIDAgMCAxIDBWOS4yMDdsMy4wMzYgMy4wMzZhLjUuNSAwIDEgMCAuNzA3LS43MDdMOS4yMDcgOC41SDEzLjVhLjUuNSAwIDAgMCAwLTFIOS4yMDdsMy4wMzYtMy4wMzZhLjUuNSAwIDEgMC0uNzA3LS43MDdMOC41IDYuNzkzeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-13657
*/
const Icon16SeatDev = memo(function Icon16SeatDev(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M8.5 2.5a.5.5 0 0 0-1 0v4.293L4.464 3.757a.5.5 0 0 0-.707.707L6.793 7.5H2.5a.5.5 0 0 0 0 1h4.293l-3.036 3.036a.5.5 0 1 0 .707.707L7.5 9.207V13.5a.5.5 0 0 0 1 0V9.207l3.036 3.036a.5.5 0 1 0 .707-.707L9.207 8.5H13.5a.5.5 0 0 0 0-1H9.207l3.036-3.036a.5.5 0 1 0-.707-.707L8.5 6.793z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16SeatDev };

//# sourceMappingURL=icon-16-seat-dev.js.map